var map = {
	"./Group 878.jpg": 292,
	"./Group 878@2x.jpg": 293,
	"./Group 879.jpg": 294,
	"./Group 879@2x.jpg": 295,
	"./Image 97.png": 296,
	"./Image 97@2x.png": 297,
	"./carousel/mahligai/1.png": 298,
	"./carousel/mahligai/2.png": 299,
	"./carousel/mahligai/3.png": 300,
	"./carousel/mahligai/4.png": 301,
	"./carousel/tropicana/1.png": 302,
	"./left.png": 124,
	"./mahligai-middle.png": 303,
	"./mahligai.png": 304,
	"./natl-camp.png": 305,
	"./shape-right.png": 306,
	"./svg-1.svg": 125,
	"./svg-10.svg": 126,
	"./svg-11.svg": 307,
	"./svg-12.svg": 127,
	"./svg-13.svg": 308,
	"./svg-14.svg": 128,
	"./svg-15.svg": 129,
	"./svg-16.svg": 130,
	"./svg-17.svg": 131,
	"./svg-2.svg": 132,
	"./svg-3.svg": 77,
	"./svg-4.svg": 78,
	"./svg-5.svg": 133,
	"./svg-6.svg": 134,
	"./svg-7.svg": 135,
	"./svg-8.svg": 136,
	"./svg-9.svg": 137,
	"./tropicana-cenang.png": 309,
	"./tropicana-middle-1.png": 138,
	"./tropicana-middle-2.png": 139,
	"./tropicana-middle.png": 310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;